export default {
    listByUser: "¡Libros para ti!",
    readed: "Leído"
}
  